import { render, staticRenderFns } from "./TabsSliderContainer.vue?vue&type=template&id=1897447f&scoped=true&"
import script from "./TabsSliderContainer.vue?vue&type=script&lang=js&"
export * from "./TabsSliderContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsSliderContainer.vue?vue&type=style&index=0&id=1897447f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897447f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
